<template>
    <div class="content columns is-multiline">
        <div class="column is-half is-full-mobile">
            <window title="Headings">
                <h1 class="title is-1 has-text-primary">Heading 1</h1>
                <h2 class="title is-2 has-text-info">Heading 2</h2>
                <h3 class="title is-3 has-text-link">Heading 3</h3>
                <h4 class="title is-4 has-text-success">Heading 4</h4>
                <h5 class="title is-5 has-text-warning">Heading 5</h5>
                <h6 class="title is-6 has-text-danger">Heading 6</h6>
            </window>
        </div>

        <div class="column is-half is-full-mobile">
            <window title="Blockquote" height="100%">
                <blockquote>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ultricies dictum
                     quam, vel eleifend erat fermentum ut. Praesent semper nisi vel condimentum
                      lobortis. Sed dignissim eros ante, in iaculis orci auctor a. Mauris ultricies,
                      risus at lobortis convallis, augue ex euismod enim, in efficitur risus libero
                      vel leo. Donec id ligula placerat, placerat diam nec, pellentesque nisi.
                      Praesent eu elit pretium, aliquet libero eget, malesuada velit. Vivamus eu leo
                      eget est consectetur efficitur. Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Aut, fugit cumque numquam laborum, quidem adipisci
                      consectetur omnis reprehenderit eum reiciendis accusamus facere dolor iure ex
                      temporibus repellendus quisquam? Impedit, consequatur. Lorem ipsum dolor, sit
                      amet consectetur adipisicing elit. Dolor exercitationem reiciendis molestias
                      tempore nobis, distinctio ab repellendus, impedit, quam perferendis eos fugit
                      rerum dolorem id debitis sint a cum ea. Lorem ipsum dolor sit amet consectetur
                      adipisicing elit. Eveniet, libero soluta? Repellendus iure beatae nobis quam
                      nam, aliquam provident ab! Quis impedit dolor voluptates neque omnis?
                      Delectus ullam voluptates distinctio!
                </blockquote>
            </window>
        </div>

        <div class="column is-full">
            <window title="Paragraph">
                <p class="m-b-md">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ultricies dictum
                    quam, vel eleifend erat fermentum ut. Praesent semper nisi vel condimentum
                    lobortis. Sed dignissim eros ante, in iaculis orci auctor a. Mauris ultricies,
                    risus at lobortis convallis, augue ex euismod enim, in efficitur risus libero
                    vel leo. Donec id ligula placerat, placerat diam nec, pellentesque nisi.
                    Praesent eu elit pretium, aliquet libero eget, malesuada velit. Vivamus eu leo
                    eget est consectetur efficitur.
                </p>
                <p class="m-b-md">
                    <strong>Phasellus</strong> enim risus, tempus vel dolor vel, auctor aliquet
                    velit. Nulla facilisi. Etiam sed velit vel enim eleifend sollicitudin quis
                    interdum diam. Fusce sollicitudin viverra ipsum, a venenatis tortor blandit non.
                    Aliquam dolor tellus, sollicitudin ut massa sit amet, tristique malesuada magna.
                    Curabitur sed metus mi. Suspendisse finibus libero ac erat imperdiet, nec
                    vehicula sapien venenatis. Sed urna urna, dignissim ut lorem sit amet, pulvinar
                    facilisis orci. Fusce ligula massa, rhoncus a rutrum id, finibus sed turpis.
                    Praesent erat libero, eleifend eu consectetur quis, finibus eget ante. Duis
                    finibus quam id risus commodo sollicitudin. Nulla felis velit, placerat dictum
                    aliquam a, malesuada vel augue. Aenean tellus dolor, fermentum eget tellus quis,
                    egestas bibendum ante. Aenean in augue feugiat mauris tempus vulputate.
                </p>

            </window>
        </div>

        <div class="column is-half is-full-mobile">
            <window title="Unordered List" height="100%">
                <ul>
                    <li>List item #1</li>
                    <li>List item #2</li>
                    <li>List item #3
                        <ul>
                            <li>List subitem #1</li>
                            <li>List subitem #2</li>
                            <li>List subitem #3</li>
                            <li>List subitem #4</li>
                        </ul>
                    </li>
                    <li>List item #4</li>
                    <li>List item #5</li>
                </ul>
            </window>
        </div>
        <div class="column is-half is-full-mobile">
            <window title="Ordered List" height="100%">
                <ol class="is-unstyled">
                    <li>List item #1</li>
                    <li>List item #2</li>
                    <li>List item #3
                        <ol>
                            <li>List subitem #1</li>
                            <li>List subitem #2</li>
                            <li>List subitem #3</li>
                            <li>List subitem #4</li>
                        </ol>
                    </li>
                    <li>List item #4</li>
                    <li>List item #5</li>
                </ol>
            </window>
        </div>

        <div class="column is-full">
            <window title="PRE">
                <pre>&lt;!DOCTYPE html&gt;
&lt;html&gt;
&lt;head&gt;
    &lt;title&gt;Hello World&lt;/title&gt;
&lt;/head&gt;
&lt;body&gt;
    &lt;p&gt;Lorem ipsum dolor sit amet, consectetur adipiscing elit.&lt;/p&gt;
&lt;/body&gt;
&lt;/html&gt;</pre>
            </window>
        </div>
    </div>
</template>

<script>
export default {};
</script>

